<template>
  <div>
    <b-card-body v-if="!wait">
      <b-card>
        <div class="section01">
          <div class="sctCol">
            <div class="labelTxt">{{ $t('occurrenceDetailsOpenIn') }}</div>
            <div>{{ occurrence.creationDate | dateBRWithoutTime }}</div>
          </div>
          <div class="sctCol">
            <div class="labelTxt">{{ $t('occurrenceDetailsPeriod') }}</div>
            <div>{{ occurrence.workshiftDescription }}</div>
          </div>
          <div class="sctCol">
            <div class="labelTxt">{{ $t('occurrenceDetailsResponsible') }}</div>
            <div>{{ occurrence.responsibleName }}</div>
          </div>
          <div v-if="occurrence.content.triggerName" class="sctCol">
            <label class="labelTxt">{{ $t('occurrenceDetailsTrigger') }}</label>
            <div>{{ occurrence.content.triggerName }}</div>
          </div>
        </div>
        <br />
        <div class="section02">
          <div class="sctCol">
            <div class="labelTxt">{{ $t('occurrenceDetailsRelatedIndicator') }}</div>
            <div>
              {{
                occurrence.indicatorName != null
                  ? occurrence.indicatorName
                  : "Não informado"
              }}
            </div>
          </div>
          <div class="sctCol">
            <div class="labelTxt">{{ $t('occurrenceDetailsGoal') }}</div>
            <div>{{ ParseNumber(occurrence.content.target) || "-" }}</div>
          </div>
          <div class="sctCol">
            <div class="labelTxt">{{ $t('occurrenceDetailsRealized') }}</div>
            <div>{{ ParseNumber(occurrence.content.value) || "-" }}</div>
          </div>
          <div class="sctCol">
            <div class="labelTxt">{{ $t('occurrenceDetailsActualValue') }}</div>
            <div>{{ ParseNumber(occurrence.content.currentValue) || "-" }}</div>
          </div>
          <div class="sctCol">
            <div class="labelTxt">{{ $t('occurrenceDetailsDeadline') }}</div>
            <div>
              <div id="deadline" class="flex-nowrap d-flex" :v-html="this.deadlineLabel(occurrence.deadlineInDays)">
              </div>
            </div>
          </div>
        </div>
        <br />
        <div v-if="showSolvace" class="rca-section">
          <div class="sctCol">
            <label class="labelTxt">RCA ID</label>
            <div>{{ occurrence.content.rcaId ? occurrence.content.rcaId : 'ID não encontrado.' }}</div>
          </div>
          <div class="sctCol">
            <label class="labelTxt">RCA Status</label>
            <div>{{ occurrence.content.rcaStatus ? occurrence.content.rcaStatus == 10 ? "Aberto" : "Fechado" : 'Status não encontrado.' }}</div>
          </div>
        </div>
        <br />
        <div class="content-origin">
          <div>
            <label class="labelTxt">{{ $t('occurrenceDetailsProcess') }}</label>
            <p>{{ occurrence.content.processName ? occurrence.content.processName : "Não informado." }}</p>
          </div>
          <div>
            <label class="labelTxt">{{ $t('occurrenceDetailsEquipment') }}</label>
            <p>{{ occurrence.content.equipmentName ? occurrence.content.equipmentName : "Não informado." }}</p>
          </div>
          <div>
            <label class="labelTxt">{{ $t('occurrenceDetailsProduct') }}</label>
            <p>{{ occurrence.content.productName ? occurrence.content.productName : "Não informado." }}</p>
          </div>
        </div>

        <div v-bind:class="{ 'reason-workOrder': occurrence.content.workOrder }">
          <div class="occurrence-reason">
            <label class="labelTxt">{{ $t('occurrenceDetailsReason') }}</label>
            <p>{{ occurrence.description }}</p>
          </div>

          <div v-if="occurrence.content.workOrder" class="occurrence-reason">
            <label class="labelTxt">Ordem de Serviço: </label>
            <p>{{ occurrence.content.workOrder }}</p>
          </div>
        </div>

        <div class="occurrence-actions">
          <label class="labelTxt mb-0">{{ $t('occurrenceDetailsActions') }}</label>
          <ActionTable :editable="editMode" :newOccurrence="false" :responsibleList="responsibleList"
            :actionsProp.sync=occurrence.content.actionsList :occurrenceStatus=occurrence.statusId
            :userEditor="this.occurrence.statusId == 1 && currentUserCanSave"
            :baseDate="this.MaskDate(occurrence.baseDate)" @updateActionsList="updateActionsList($event)">
          </ActionTable>
        </div>

        <div
          v-if="(this.occurrence.system != 'P' && user.role == 'GDI') || (this.occurrence.system == 'P' && user.role == 'PGDI')"
          class="occurrence-observation">
          <label class="labelTxt">{{ $t('occurrenceDetailsNotes') }}</label>
          <textarea name="observation" :disabled="!editMode" v-model="occurrence.observation"
            :placeholder="$t('occurrenceDetailsPlaceholderNotes')" rows="3">
                                                                                    </textarea>
        </div>

        <div
          v-if="(this.occurrence.system != 'P' && user.role == 'GDI') || (this.occurrence.system == 'P' && user.role == 'PGDI')"
          class="occurrence-leasonLearned">
          <label class="labelTxt">{{ $t('occurrenceDetailsLessonsLearned') }}</label>
          <textarea name="leasonLerned" :disabled="!editMode" v-model="occurrence.content.lessonsLearned"
            :placeholder="$t('occurrenceDetailsPlaceholderLessonsLearned')" rows="3">
                                                                                    </textarea>
        </div>

        <div v-if="this.occurrence && this.occurrence.statusId != 1">
          <br />
          <span class="labelTxt">Ocorrência: </span>
          {{ this.occurrence.statusId == 2 ? "FECHADA" :
            this.occurrence.statusId == 4 ? "EM ANALISE" : "CANCELADA" }}
        </div>
        <div v-if="this.occurrence && this.occurrence.replanned" class="replannedStatus">
          <br />
          Replanejado por: {{ this.occurrence.replannedBy }}
        </div>

        <div>
          <b-icon
            v-if="(((this.occurrence.statusId == 1 && this.editMode) || (this.occurrence.statusId == 1 && currentUserCanSave)) && user.Permissions.fecharocorrenciageral.allowed)"
            :disabled="!isPresentActionList" @click="isPresentActionList ? $bvModal.show('confirmClose') : null"
            :title="isPresentActionList ? $t('closeOccurrenceWithoutAnalysisButtom') : $t('closeOccurrenceWithoutAnalysisInfo')"
            :class="{ 'icon-close': isPresentActionList, 'disabled-icon': !isPresentActionList }"
            :style="{ cursor: isPresentActionList ? 'pointer' : 'not-allowed' }" icon="skip-end-fill"
            aria-hidden="true">
          </b-icon>

          <div id="icons" class="d-flex justify-content-end mt-3">
            <img v-if="this.occurrence.statusId == 1 && this.editMode"
              @click="(allCompletedActions && isPresentActionList) ? $bvModal.show('confirmAction') : null"
              class="ml-3 cursor-button"
              :src="(allCompletedActions && isPresentActionList) ? require('../../../assets/saveNext.png') : require('../../../assets/saveNextDisabled.png')"
              :title="(allCompletedActions && isPresentActionList) ? $t('start-automatic-validation') : $t('start-automatic-validation-info')"
              :alt='$t("start-automatic-validation")'
              :style="{ cursor: (allCompletedActions && isPresentActionList) ? 'pointer' : 'not-allowed' }" />
            <img
              v-if="(this.occurrence.statusId == 1 && this.editMode) || (this.occurrence.statusId == 1 && currentUserCanSave)"
              @click="save" class="ml-3 cursor-button" src="../../../assets/salvar.png" :title="$t('save')"
              alt="Salvar ocorrência" />
            <img v-if="this.occurrence.statusId == 1 && this.editMode && this.canCancelPerm" @click="$bvModal.show('confirmCancel')"
              class="ml-3 cursor-button" src="../../../assets/excluir.png" :title="$t('cancel')"
              alt="Cancelar ocorrência" />
            <img @click="closeForm" class="ml-2 cursor-button" src="../../../assets/sair.png" :title="$t('exit')"
              alt="Sair" />
          </div>
        </div>


        <b-modal id="confirmAction" ok-variant="danger" :ok-title="$t('yes')" :cancel-title="$t('no')"
          @ok="closeOccurrence">{{ $t('confirmCloseOccurrenceMessage') }}</b-modal>
        <b-modal id="confirmCancel" size="md" hide-footer :title="$t('confirCancelOccurrence')"
          :no-close-on-backdrop="true">
          <MessageBox class='msgBox' @motivo="recebe($event)" modelname="confirmCancel" :action="cancelOccurrence" />
        </b-modal>
        <b-modal id="confirmClose" size="md" hide-footer :title="$t('confirmCloseOccurrence')"
          :no-close-on-backdrop="true">
          <MessageBoxClose class='msgBox' @motivo="recebe($event)" modelname="confirmClose"
            :action="closeDefinitiveFunction" />
        </b-modal>
      </b-card>
    </b-card-body>
    <b-card-body v-else>
      <p>{{ $t('loadingOccurrenceDataMessage') }}</p>
    </b-card-body>
  </div>
</template>
<script>
import axios from "axios";
import { urlMainAPI, showError, defaultSuccess } from "@/global";
import { FiltersMixin } from "../../mixins/filtersMixin";
import { mapState } from "vuex";
import * as moment from "moment";
import "moment/locale/pt-br";
import STATUS from "../../occurrence/statusEnum"
import ActionTable from '../../occurrence/actionTable.vue';
import MessageBox from '../../template/MessageBoxInputModal.vue';
import MessageBoxClose from '../../template/MessageBoxInputModalClose.vue';

export default {
  name: "OccurrenceDetails",

  components: { ActionTable, MessageBox, MessageBoxClose },

  props: {
    nodeSelected: Object,
    loadTree: Function,
    nameForm: String,
    lastIndicatorNodeSelected: Object
  },

  mixins: [FiltersMixin],

  computed: mapState(["user", "system"]),

  data() {
    return {
      wait: true,
      editMode: false,
      occurrence: {},
      occurrenceBkp: {},
      currentSystem: "",
      activeReplanned: false,
      responsibleList: [],
      actions: [],
      motivo: '',
      allCompletedActions: false,
      currentUserCanSave: false,
      showSolvace: false,
      isPresentActionList: false,
      canCancelPerm: false 
    };
  },


  watch: {

  },

  filters: {
    dateBRWithoutTime(date) {
      let dateBr = Date.parse(date);
      dateBr = new Date(dateBr);
      dateBr = dateBr.toLocaleString("pt-BR");
      // let info = dateBr.split(" ");
      // dateBr = info[0];
      if (dateBr == "Invalid") {
        return "erro";
      }
      return dateBr.replace(/,$/, '');
    },
  },

  methods: {
    recebe(data) {
      this.motivo = data;
    },

    checkPermission() {
      const solvacePermission = this.user.Permissions.enviarocorrenciasparasolvace;

      if (solvacePermission != undefined) 
      {
        if (solvacePermission.allowed == true) 
        {
          this.showSolvace = true
        }
      }

      const cancelPermission = this.user.Permissions.cancelarocorrencia;

      if (cancelPermission != undefined) 
      {
        if (cancelPermission.allowed == true) 
        {
          this.canCancelPerm = true
        }
      }
    },

    save() {
      this.saveOccurrence();
      this.closeForm()
    },

    cancelOccurrence() {
      if (this.motivo.trim().length == 0) {
        showError(this.$t('necessario-informar-o-motivo-do-cancelamento'));
        return
      }
      let text = `${this.occurrence.description} |
      Cancelada: ${this.motivo}
      `
      this.occurrence.description = text;
      this.occurrence.statusId = 3;
      this.saveOccurrence();
      this.$bvModal.hide('confirmCancel')
      this.closeForm()
    },

    closeDefinitiveFunction() {
      if (this.motivo.trim().length == 0) {
        showError(this.$t('necessario-informar-o-motivo-do-fechamento'));
        return
      }
      let text = `${this.occurrence.description} |
      Fechada: ${this.motivo}
      `
      this.occurrence.description = text;
      this.occurrence.statusId = 2;
      this.occurrence.statusId = 2;
      this.occurrence.finishedDate = moment().format("YYYY-MM-DD HH:mm:ss")
      this.occurrence.deadline = moment().format("YYYY-MM-DD HH:mm:ss")
      this.saveOccurrence();
      this.$bvModal.hide('confirmCancel')
      this.closeForm()
    },

    deadlineLabel(deadlineInDays) {
      let result = "";

      if (this.occurrence.statusId == 2 || this.occurrence.statusId == 3)
        result = (
          "<span class='d-flex align-items-center'>" +
          deadlineInDays +
          `</span>`
        );
      else if (deadlineInDays < 0) {
        result = (
          "<span class='d-flex align-items-center'>" +
          deadlineInDays +
          `<img class="ml-1" src="${require("@/assets/semaforoVermelho.png")}" width="16" height="16" alt="Alert" /></span>`
        );
      }
      else
        result = (
          "<span class='d-flex align-items-center'>" +
          deadlineInDays +
          `<img class="ml-1" src="${require("@/assets/semaforoVerde.png")}" width="16" height="16" alt="OK" /></span>`
        );
      setTimeout(() => {
        let el = document.getElementById("deadline")
        if (el)
          el.innerHTML = result;
      }, 100);
    },

    async saveOccurrence() {
      this.occurrence.replanned = this.checkReplannedParameters()
      this.occurrence.replannedBy = this.occurrence.replanned == true ? this.user.FullName : "";

      let occurrenceToSend = JSON.parse(JSON.stringify(this.occurrence))
      let content = JSON.parse(JSON.stringify(this.occurrence.content))
      content.actionsList = new Array();

      if (this.occurrence.content.actionsList) {
        this.occurrence.content.actionsList.forEach(a => {
          content.actionsList.push({
            action: a.action,
            date: this.MaskDate(a.date),
            responsableId: a.responsible.id,
            responsableUnitId: a.responsible.unitId,
            responsableSystem: a.responsible.system,
            closingDate: a.closingDate,
            status: a.status
          })
        })
      }

      occurrenceToSend.content = JSON.stringify(content)
      occurrenceToSend.indicatorId = JSON.parse(this.occurrence.indicatorId)
      occurrenceToSend.deadline = await this.getDeadLine();

      defaultSuccess(this.$t('salvando-dados'))

      const url = `${urlMainAPI}/saveoccurrence`;
      axios.post(url, occurrenceToSend)
        .then((res) => {
          defaultSuccess(res.data);
          this.loadTree();
          this.deadlineInDays = this.todayToDeadlineInDays;
          this.deadlineLabel(this.todayToDeadlineInDays);
        })
        .catch((er) => {
          showError(er.data);
        });
    },

    async getDeadLine() {
      let deadLine = '1900-01-01'

      if (this.occurrence.statusId == 3)
        return moment().format().substring(0, 10) + " 23:59:59";

      await this.occurrence.content.actionsList.forEach(a => {
        let date = this.formatBaseDate(a.date);
        let diff = moment(date, "YYYY-MM-DD").diff(moment(deadLine, "YYYY-MM-DD"))
        let isPending = a.status == STATUS.PENDING || a.status == STATUS.LATE

        if (diff > 0 && isPending) {
          deadLine = date;
        }
      })

      return deadLine + " 23:59:59";
    },

    formatBaseDate(baseDate) {
      if (typeof baseDate == "object") {
        baseDate = baseDate.format().substring(0, 10);
      } else {
        baseDate = baseDate.split("/").reverse();
        baseDate = baseDate.join("-");
      }
      return baseDate;
    },


    updateActionsList(actionslist) {
      this.occurrence.content.actionsList = actionslist
      this.isPresentActionList = actionslist
      this.allActionsClosed()
      this.calcDeadline()
    },

    async allActionsClosed() {

      let pendingActions = this.occurrence.content.actionsList.filter(item => item.status == null || item.status == undefined || item.status === STATUS.PENDING)

      if (this.occurrence.content.actionsList.length > 0 && pendingActions.length <= 0) {
        this.allCompletedActions = true;
        this.isPresentActionList = true;
      } else {
        this.allCompletedActions = false;
        this.isPresentActionList = false;
      }
    },

    async calcDeadline() {
      this.occurrence.deadlineInDays = -120
      let baseDate = this.MaskDate(new Date())

      if (this.occurrence.content.actionsList.length > 0) {
        await this.occurrence.content.actionsList.forEach(a => {
          if (this.occurrence.statusId == 1 && !this.occurrence.content.closingDate &&
            (!a.status || (a.status != STATUS.CANCELED && a.status != STATUS.COMPLETED && a.status != STATUS.COMPLETED_LATE))) {
            let days = this.DiffInDays(baseDate, a.date)
            if (days > this.occurrence.deadlineInDays) {
              this.occurrence.deadlineInDays = days
            }
          }
        })
      }
      else {
        let days = this.DiffInDays(baseDate, this.MaskDate(this.occurrence.deadline))
        this.occurrence.deadlineInDays = days
      }

      if (this.occurrence.deadlineInDays == -120 || this.occurrence.deadline == "1900-01-01 23:59:59" || !this.occurrence.deadline)
        this.occurrence.deadlineInDays = 0

    },

    closeOccurrence() {
      if (this.nodeSelected.system == "P" && this.user.role == "GDI") {
        showError(this.$t('nao-e-possivel-alterar-ocorrencia-do-pgdi'));
        return;
      }

      this.occurrence.content.requestClosing = true;
      this.occurrence.statusId = 4
      this.occurrence.sentAnalysis = moment().format("YYYY-MM-DD HH:mm:ss")
      this.occurrence.profileId = 3

      this.saveOccurrence();
      this.closeForm();
    },

    closeForm() {
      let form = this.nameForm ? this.nameForm : "OccurrenceDetails"
      this.$bvModal.hide(form);
    },

    async loadContent() {
      let content = typeof this.occurrence.content === "string" ? JSON.parse(this.occurrence.content) : this.occurrence.content;

      if (!content)
        return

      content.actionsList = content.actionsList ? content.actionsList : [];
      content.actionsList = await content.actionsList.map((a, i) => ({ ...a, id: i }))
      this.occurrence.content = content
    },

    async loadResponsibleList() {
      const unitId = this.nodeSelected.productionUnitId;

      const url = `${urlMainAPI}/getresponsiblesbyunit/${unitId}`;
      await axios.get(url).then((res) => {
        if (typeof res.data == "string") this.responsibleList = [];
        else this.responsibleList = res.data.responsibleList;
      });
    },

    async loadOcurrenceDetails() {
      this.wait = true;

      const occurrenceInf = {
        id: this.nodeSelected.id,
        productionUnitId: this.nodeSelected.productionUnitId,
        baseDate: this.nodeSelected.baseDate,
        system: this.nodeSelected.system,
      }

      const url = `${urlMainAPI}/getoccurrence`;
      await axios.post(url, occurrenceInf).then(async (res) => {
        if (res.data) {
          this.occurrence = res.data.occurrence;
        }
        else
          this.occurrence = {};

        this.occurrence.content = this.occurrence.content ? this.occurrence.content : {}
        await this.loadContent();
        await this.allActionsClosed();
        await this.calcDeadline();
        this.occurrenceBkp = JSON.parse(JSON.stringify(this.occurrence))
        this.wait = false;
      }).catch(console.log)
    },

    checkEditModel() {
      let isValidUser = ((this.user.Id == this.occurrence.responsibleId &&
        this.user.UnitId == this.occurrence.responsibleUnitId) ||
        this.user.Permissions.replanejarocorrencias.allowed)
      let isValidOccurrence = this.occurrence.statusId == 1 && this.occurrence.system == this.currentSystem

      this.editMode = isValidUser && isValidOccurrence
    },


    checkReplannedParameters() {
      let replanned = false;
      // Quantidade de ações alteradas 
      if (this.occurrenceBkp.content.actionsList.length != this.occurrence.content.actionsList.length) {
        replanned = true
      }

      // Alterações em ação 
      this.occurrence.content.actionsList.forEach(o => {
        let founded = this.occurrenceBkp.content.actionsList.find(bkp => bkp.id == o.id)
        if (founded == null)
          replanned = true

        if (founded && founded.date != o.date)
          replanned = true

        if (founded && founded.action != o.action)
          replanned = true

        if (founded && founded.status != o.status && o.status == STATUS.CANCELED)
          replanned = true
      })

      return replanned
    },


    async canSaveByNotResponseble() {
      if (this.occurrence.statusId == 1) {
        await this.occurrence.content.actionsList.forEach(a => {
          if (a.responsableId == this.user.Id && a.responsableUnitId == this.user.UnitId && (a.status == STATUS.PENDING || a.status == STATUS.LATE))
            this.currentUserCanSave = true;
        })
      }
    }
  },

  async created() {
    this.currentSystem = this.system == "GDI" ? "G" : "P";
    this.loadResponsibleList();
    await this.loadOcurrenceDetails();
    this.canSaveByNotResponseble();
    this.checkEditModel();
    this.checkPermission();
  },

  destroyed() {
    if (this.lastIndicatorNodeSelected) this.$emit("getLastIndicatorNodeSelected", this.lastIndicatorNodeSelected)
  },

  mounted() {
    console.log(this.isPresentActionList)
  },
};
</script>

<style scoped>
.icon-close {
  color: rgb(255, 113, 0);
  font-size: 55px;
  position: absolute;
  bottom: 8px;
  cursor: pointer;
}

.disabled-icon {
  color: #8B8D90;
  font-size: 55px;
  position: absolute;
  bottom: 8px;
  cursor: pointer;
}

.closeOc {
  float: left;
}

.section01 {
  display: grid;
  grid-template-columns: 1fr 1fr 2fr 1fr 1fr;
}

.section02 {
  display: grid;
  grid-template-columns: 4fr 1fr 1fr 1fr 1fr;
}

.sctCol {
  display: grid;
  grid-template-rows: auto auto;
}

.replannedStatus {
  color: red;
  font-style: italic;
  font-weight: 400;
  font-size: 0.8em;
}

.labelTxt {
  font-weight: 700;
  margin-bottom: 0px;
}

textarea {
  border: 2px solid #343a40;
  border-radius: 5px;
}

.occurrence-reason,
.occurrence-leasonLearned>textarea,
.occurrence-observation>textarea {
  width: 100%;
}

.cursor-button {
  cursor: pointer;
  height: 35px;
  width: 35px;
}

.occurrence-info {
  font-size: 20px;
}

#occurrence-date {
  font-size: 24px;
}

#occurrence-divisor {
  display: none;
}

.indicatorTxt {
  min-width: 680px;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
}

.content-origin {
  display: grid;
  grid-template-columns: 33.33% 33.33% 33.33%;
}

.reason-workOrder {
  display: grid;
  grid-template-columns: 50% 50%;
}

.rca-section {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  column-gap: 3rem;
}

@media only screen and (max-width: 1199px) {}

@media only screen and (max-width: 740px) {}

@media only screen and (max-width: 576px) {}
</style>
